/*
  Карточка «Обзвон идёт» - вариант Б, решение владельца 06.10.2026.

  Отвечает на четыре вопроса подряд: сколько сделано, кому звоним прямо сейчас,
  чем кончились последние звонки и кто следующий. Звонок за раз один, и обзвон
  пятисот должников идёт днями: без этой карточки человек не отличил бы
  «идёт» от «застрял».

  Ночью обзвон не пропускает должников, а замирает до утра - карточка говорит,
  когда продолжит (`resume_at`). Время показывается по часам того, кто смотрит:
  разрешённые часы считаются по времени должника, и «8:00» без пояса здесь
  читалось бы как своё утро.
*/

import { Link } from 'react-router-dom'

import { dateTime } from '../api/format.js'
import { Notice, Tag } from './Common.jsx'

function time(value) {
  return value ? dateTime(value).slice(-5) : ''
}

function who(item) {
  return [item.debtor_name, `счёт ${item.account_number}`, item.phone].filter(Boolean).join(', ')
}

function Progress({ counts }) {
  const done = counts.answered + counts.not_answered + counts.unknown
  const share = (part) => `${counts.total ? (100 * part) / counts.total : 0}%`
  return (
    <div className="wave-progress" aria-hidden="true">
      <span className="wave-progress__done" style={{ width: share(done) }} />
      <span className="wave-progress__skipped" style={{ width: share(counts.skipped) }} />
    </div>
  )
}

export default function CallWaveCard({ wave, onStop, stopping, error, stopError = null }) {
  const { counts } = wave
  const running = wave.state === 'running'
  return (
    <div className="card">
      <div className="row">
        {/* Подпись состояния - с сервера («идёт», «остановлен: линия не приняла
            вызов»): своя копия подписей разошлась бы с ней. */}
        <div className="section__title">Обзвон {wave.state_title}</div>
        <Tag kind={running ? 'calm' : 'muted'}>запущен {dateTime(wave.started_at)}</Tag>
        <Tag kind="muted">по одному звонку</Tag>
      </div>

      <Progress counts={counts} />
      <div className="row">
        <Tag kind="calm">поговорили: {counts.answered}</Tag>
        {/* «Не дозвонились», а не «не взяли трубку»: сюда же сервер считает
            «занято» и отказ линии - трубку в них никто не брал и не мог. */}
        <Tag kind="muted">не дозвонились: {counts.not_answered}</Tag>
        <Tag kind="warn">осталось: {counts.pending}</Tag>
        <Tag kind="muted">пропущено по правилам: {counts.skipped}</Tag>
        {counts.unknown ? <Tag kind="muted">исход неизвестен: {counts.unknown}</Tag> : null}
      </div>

      {running && wave.resume_at ? (
        <Notice kind="warn">
          <div className="notice__what">Сейчас вне разрешённых часов.</div>
          <div className="notice__do">
            Обзвон продолжит сам {dateTime(wave.resume_at)} по вашему времени - с началом
            разрешённых часов у должника.
          </div>
        </Notice>
      ) : null}
      {wave.stop_reason ? (
        <Notice kind="warn">
          <div className="notice__what">Почему остановлен.</div>
          <div className="notice__do">{wave.stop_reason}</div>
        </Notice>
      ) : null}

      {wave.current ? (
        <p>
          Сейчас звоним: <b>{who(wave.current)}</b>
        </p>
      ) : null}

      {wave.recent.length ? (
        <div className="log">
          {wave.recent.map((item) => (
            <div className="log__row" key={item.account_id}>
              {/* Пропущенный по правилам не набирался, и времени у него нет -
                  вместо пустого места стоит, что с ним. */}
              <span className="log__when">{time(item.finished_at) || item.state_title}</span>
              <Link to={`/accounts/${item.account_id}`}>Счёт {item.account_number}</Link>
              <span>
                {item.debtor_name ? `${item.debtor_name} - ` : ''}
                <span className="muted">{item.outcome_title ?? item.note ?? item.state_title}</span>
              </span>
            </div>
          ))}
        </div>
      ) : null}

      {running && wave.upcoming.length ? (
        <div className="muted">
          Следующие: {wave.upcoming.map((item) => `счёт ${item.account_number}`).join(', ')}
          {counts.pending > wave.upcoming.length ? ' и другие' : ''}.
        </div>
      ) : null}

      {running ? (
        <>
          <div className="muted">
            Перед каждым звонком правила проверяются заново. Если линия откажет, обзвон остановится
            сам и скажет почему. Начатый разговор кнопка не обрывает.
          </div>
          <Notice error={error} />
          <div className="row">
            <button
              type="button"
              className="button button--quiet"
              disabled={stopping}
              onClick={onStop}
            >
              {stopping ? 'Останавливаем…' : 'Остановить обзвон'}
            </button>
          </div>
          {/* Отказ остановки - под самой кнопкой и не уходит сам: обзвон при этом идёт. */}
          <Notice error={stopError} />
        </>
      ) : (
        <Notice error={error} />
      )}
    </div>
  )
}
